import Swiper from 'swiper/dist/js/swiper.js';
import owd from 'owd/owd';

export default class Slider extends owd.Component {
	init() {
		this.count = this.$element.find('.slider-slide').length;
		this.pagination = this.$element.find('.slider-pagination');
		this.curr = 1;

		this.prepareDom();
		this.createSlider();
		this.bind();

	}

	prepareDom() {
		this.$element.append('<div class="swiper-container"><div class="swiper-wrapper"></div></div>');
		this.$element.find('.swiper-wrapper').append(this.$element.find('.slider-slide'));
		this.$element.find('.slider-slide').addClass('swiper-slide').each((index, item) => {
			$(item).attr('data-slide-number', index);
		});

		this.$swiperContainer = this.$element.find('.swiper-container');
	}

	setActiveSlide() {
		this.on('domready load ajaxload', this.dom.$window, () => {
			if (this.$element.is('[data-slider-tickets]')) {
				this.$activeTicket = this.$element.find('.active');
				this.$activeIndex = this.$activeTicket.data('swiper-slide-index');

				return this.$activeIndex;
			}
		})
	}

	getOptions() {
		let keyboard = true;
		let effect = 'slide';
		let autoplay = false;
		let speed = 500;
		let lazyload = this.$swiperContainer.find('.swiper-lazy').length ? true : false;
		let lazy = lazyload ? {
			loadPrevNext: lazyload,
			loadPrevNextAmount: 2,
		} : false;

		let navigation = {
			prevEl: this.$element.find('.tickets-nav-arrow--left')[0],
			nextEl: this.$element.find('.tickets-nav-arrow--right')[0]
		}

		let navigationHome = {
			prevEl: this.$element.find('.nav--prev')[0],
			nextEl: this.$element.find('.nav--next')[0]
		}

		let pagination = {
			el: this.$element.find('.slider-pagination'),
			type: 'bullets',
			clickable: true,
			bulletElement: 'span',
			// renderBullet: function (index, className) {
			// 	return '<button type="button" class="' + className + '"></button>';
			// },
			// bulletClass: 'slider-pagination-item',
			// bulletActiveClass: 'is-active',
			// modifierClass: 'slider-pagination-',
			// clickableClass: 'is-clickable'
		}

		let options = {
			keyboard: keyboard,
			effect: effect,
			loop: true,
			initialSlide: 0,
			slidesPerView: 'auto',
			centeredSlides: true,
			loopedSlides: this.count,
			speed: speed,
			autoplay: autoplay,
			preloadImages: !lazyload,
			lazy,
			// navigation : navigation,e
			spaceBetween: 0,
			pagination: pagination,
			preventClicks: true,
			preventClicksPropagation: true,
			breakpoints: {
				1023: {
					spaceBetween: 0
				},
				767: {
					spaceBetween: 0
				}
			}

		};

		if (this.$element.is('[data-slider-home]')) {
			options.effect = 'fade';
			options.navigation = navigationHome;
			options.spaceBetween = 0;
		}

		if (this.$element.is('[data-slider-tickets]')) {
			this.$activeTicket = $('.tickets-nav--desktop').find('.active');
			this.$activeIndex = this.$activeTicket.data('lineup');

			options.initialSlide = this.$activeIndex;
			options.navigation = navigation;
		}

		if (this.$element.is('[data-slider-tickets-new]')) {
			options.pagination = pagination;
			options.on = {
				init: () => {
					const slider = this.$element[0].querySelector('.swiper-container').swiper;

					slider.slideTo(options.initialSlide ? options.initialSlide : 0, 0);
				}
			}
		}

		if (this.$element.data('slider-initial-slide')) {
			this.curr = Math.max(Math.min(this.$element.data('slider-initial-slide'), this.count), 1);
			options.initialSlide = this.curr - 1;
		}

		return options;
	}

	createSlider() {
		let options = this.getOptions();

		this.swiper = new Swiper(this.$swiperContainer[0], options);

		this.$element.data('swiperInstance', this.swiper);
		this.$element.trigger('sliderInitialized', this.swiper);
	}

	calcPaginationPos() {
		if (this.$element.is('[data-slider-news]') && window.innerWidth < 768) {
			this.figureHeight = $('.news-slider-img').outerHeight();
			return this.pagination.css('top', this.figureHeight);

		} else if (this.$element.is('[data-slider-home]') && window.innerWidth < 768) {
			this.figureHeight = $('.slide-photo').outerHeight();
			return this.pagination.css('top', this.figureHeight);

		} else {
			return this.pagination.css('top', '');
		}
	}

	navigationColorsUpdate() {
		setTimeout(() => {
			if (this.$element.is('[data-slider-home]')) {
				const activeColor = this.$element.find('.swiper-slide-active').data('nav-color') || 'rgb(0, 0, 0)';
				const navigation = this.$element.find('.nav path');
				navigation.css('fill', activeColor);
			}
		});
	}

	bind() {
		this.on('slideChangeTransitionStart', this.swiper, () => {
			this.curr = parseInt(this.$element.find('.swiper-slide-active').data('slide-number')) + 1;
			$('.curr-slide').html(this.curr);

			if (this.$element.is('.tickets-nav--mobile') && window.matchMedia('(max-width: 1023px)').matches) {
				const slideIndex = this.swiper.realIndex;
				$(this.swiper.slides[slideIndex]).trigger('click');
			}

			if (this.$element.is('[data-slider-tickets-new]') && window.matchMedia('(max-width: 767px)').matches) {
				let done = false;
				this.$element.css('pointer-events', 'none');
				const slideIndex = this.swiper.realIndex;
				if (!done) {
					$(this.swiper.slides[slideIndex]).trigger('click');
					setTimeout(() => {
						done = true;
					}, 500);
				}
			}
		});

		this.on('domready load ajaxload pageIn pageInEnd imageload', this.dom.$window, (e) => {
			if (this.swiper) {
				this.swiper.update();

				if (this.$element.is('[data-slider-news]')) {
					$('.swiper-slide-active').addClass('heading-is-visible');
				}
			}
		});

		this.on('transitionEnd', this.swiper, () => {
			if (this.$element.is('[data-slider-news]')) {
				this.slides = $('.slider-slide');

				this.slides.each((i, obj) => {
					if ($(obj).hasClass('swiper-slide-active')) {
						$(obj).addClass('heading-is-visible');
					}
				})
			}

			if (this.$element.is('[data-slider-tickets-new]') && window.matchMedia('(max-width: 767px)').matches) {
				this.$element.css('pointer-events', '');
			}
		});

		this.on('slideChangeTransitionStart slideNextTransitionStart slidePrevTransitionStart sliderMove', this.swiper, () => {
			if (this.$element.is('[data-slider-news]')) {
				$('.slider-slide').removeClass('heading-is-visible');
			}
		})

		this.on('imageload', 'img', (e) => {
			if (this.swiper) {
				this.swiper.update();
			}
		});

		this.on('load ajaxload resize-x', this.dom.$window, () => {
			if (this.swiper) {
				this.calcPaginationPos();
			}
		});

		this.on('slideChange', this.swiper, () => {
			this.navigationColorsUpdate();
		});

		this.on('load ajaxload', this.dom.$window, () => {
			this.navigationColorsUpdate();
		})
	}

	destroy() {
		super.destroy();

		if (this.slider) {
			this.swiper.destroy();
		}
	}
}

owd.registerComponent('slider', {
	component: Slider
});
